import { combineReducers } from 'redux'
import global from 'containers/Role/Global/reducer'
import project from 'containers/Role/Project/reducer'

export default combineReducers({
  global,
  project
})
